import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.ADD_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/addAction.js